'use client';
import { useSearchParams, usePathname, useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

export default function Pagination({ totalPage }) {
    const searchParams = useSearchParams();
    const pathname = usePathname();
    const { replace } = useRouter();

    // Get current page from URL or default to 1
    const currentPage = Number(searchParams.get('page')) || 1;
    const [page, setPage] = useState(currentPage);

    useEffect(() => {
        const params = new URLSearchParams(searchParams);
        if (page > 1) {
            params.set('page', page);
        } else {
            params.delete('page');
        }
        replace(`${pathname}?${params.toString()}`);
    }, [page, replace, pathname]); // Only update when `page` changes

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPage) {
            setPage(newPage);
        }
    };
    if (totalPage === 1) return
    return (
        <div className="flex gap-2">
            <button
                onClick={() => handlePageChange(page - 1)}
                disabled={page <= 1}
                className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
            >
                Prev
            </button>
            <span className="px-4 py-2">{page} / {totalPage}</span>
            <button
                onClick={() => handlePageChange(page + 1)}
                disabled={page >= totalPage}
                className="px-4 py-2 bg-gray-200 rounded disabled:opacity-50"
            >
                Next
            </button>
        </div>
    );
}
